import { useEffect } from 'react';

export function BulkDownload(props) {

	const handleScroll = () => {
		const container = document.querySelector('.employee-comms-results-group');
		const containerRect = container.getBoundingClientRect();

		let toolkitFilterHeight = 56;
		if( window.innerWidth >= 768 && window.innerWidth < 1050) {
			toolkitFilterHeight = 120;
		}

		// const toolkitFilterBar = document.querySelector('#toolkit-filter-bar');
		const appElm = document.querySelector('#employee-toolkit-page');
		if (containerRect.top < toolkitFilterHeight) {
			appElm.classList.add('pinned-filter');
			// toolkitFilterBar.style.borderRadious = 0;
		} else {
			appElm.classList.remove('pinned-filter');
		}
	};

	useEffect(() => {
		// IntersectionObserver does not work nicely here, so we'll use scroll event listener.
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	let count = 0;
	props.filteredPosts.forEach(function (section) {
		count = count + section[1].length;
	});
	const countString = count === 1 ? '1 result' : count + ' results';
	const hasDownloads = props.downloadPostList.length > 0;
	const handleDownloadAll = (event) => {
		props.toggleDownloadAll(event.target.checked);
	}

	let className = 'employee-comms-results-bulk-download row';
	let mobileDownloadBtn = document.querySelector('#download-mobile-btn');
	if (props.downloadPostList.length > 0) {
		className += ' active';
		mobileDownloadBtn.classList.add('active');
	} else if (mobileDownloadBtn !== null && mobileDownloadBtn.classList.contains('active')) {
		mobileDownloadBtn.classList.remove('active');
	}

	let bulkDownloadCheckboxClass = 'employee-comms-select-all employee-comms-checkbox';
	if (props.downloadPostList.length > 0 && count !== props.downloadPostList.length) {
		bulkDownloadCheckboxClass += ' employee-comms-checkbox--partial';
	}
	let downloadBtnStr = 'Download ' + props.downloadPostList.length + ' document'
	if (props.downloadPostList.length !== 1) {
		downloadBtnStr += 's';
	}

	return (
		<div className={className}>
			<div className="col-6 col-md-9 d-flex align-items-center pl-2">
				<input
					type="checkbox"
					id="employee-comms-select-all"
					className={bulkDownloadCheckboxClass}
					onChange={handleDownloadAll}
					defaultChecked={hasDownloads}
					key={'employee-comms-select-all-' + hasDownloads}
				/><label htmlFor="employee-comms-select-all"><span className="screen-reader-text">Add all to bulk download</span></label>
				<a className="multi-download-button btn d-none d-md-block has-cobalt-color ml-3" role="button" href="#download">{downloadBtnStr}</a>
			</div>
			<div className="col-6 col-md-3 text-end align-self-center"><span className="employee-comms-results-count">{countString}</span></div>
		</div>

	);
}
export default BulkDownload;
